import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import getLiquidations, { url, } from "../requests/getLiquidations";
export default function useGetLiquidations(authConfig) {
    const { data: queryData, status: queryStatus, error: queryError, } = useQuery({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: authConfig === null ? undefined : [authConfig.clientId, url()],
        queryFn: async () => authConfig === null ? undefined : getLiquidations(authConfig),
        enabled: authConfig !== null,
    });
    const result = useMemo(() => {
        if (queryStatus === "error") {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: queryError,
            };
        }
        if (queryStatus === "loading") {
            return { data: undefined, isLoading: true, hasError: false };
        }
        if (queryData === undefined) {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: new Error("Unknown error"),
            };
        }
        const zippedLiquidations = queryData.liquidations.map((l) => ({
            createTime: l.createTime,
            modifyTime: l.modifyTime,
            transferId: l.transferId,
            status: l.status,
            liquidationId: l.liquidationId,
            physicalAccountId: l.physicalAccountId,
            amount: l.amount,
            isFullLiquidation: l.isFullLiquidation,
        }));
        return { data: zippedLiquidations, isLoading: false, hasError: false };
    }, [queryData, queryStatus, queryError]);
    return result;
}
//# sourceMappingURL=useGetLiquidations.js.map